import React, { useState } from 'react';
import { Mail, Phone, MapPin, Clock, Send, CheckCircle } from 'lucide-react';
import './Contact.css';

const contactInfo = [
  { icon: <MapPin size={20} />, label: 'Office Address', value: '4th Floor, TechPark One, Baner Road, Pune - 411045, Maharashtra, India' },
  { icon: <Phone size={20} />, label: 'Phone', value: '+91 90999 09090' },
  { icon: <Mail size={20} />, label: 'Email', value: 'info@rocketontime.in' },
  { icon: <Clock size={20} />, label: 'Business Hours', value: 'Monday – Friday: 9:00 AM – 7:00 PM IST' },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', company: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => { setLoading(false); setSubmitted(true); }, 1500);
  };

  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="container">
          <span className="section-label">Get In Touch</span>
          <h1>Let's Start a <span>Conversation</span></h1>
          <p>Whether you have a defined project or an early-stage idea, we'd love to hear from you and explore how we can help.</p>
        </div>
      </section>

      <section className="section">
        <div className="container contact-grid">
          {/* Form */}
          <div className="contact-form-wrap">
            <h2 className="form-title">Send Us a Message</h2>
            <div className="gold-line" />

            {submitted ? (
              <div className="success-state">
                <CheckCircle size={48} />
                <h3>Message Received!</h3>
                <p>Thank you for reaching out. One of our consultants will contact you within 24 business hours.</p>
                <button className="btn-primary" onClick={() => { setSubmitted(false); setForm({ name: '', email: '', phone: '', company: '', service: '', message: '' }); }}>
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Your full name" required />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@company.com" required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" />
                  </div>
                  <div className="form-group">
                    <label>Company Name</label>
                    <input type="text" name="company" value={form.company} onChange={handleChange} placeholder="Your company" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Service of Interest</label>
                  <select name="service" value={form.service} onChange={handleChange}>
                    <option value="">Select a service</option>
                    <option>Custom Software Development</option>
                    <option>Cloud Solutions & DevOps</option>
                    <option>Cybersecurity Services</option>
                    <option>IT Consulting & Strategy</option>
                    <option>Data Analytics & BI</option>
                    <option>Mobile App Development</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Tell Us About Your Project *</label>
                  <textarea name="message" value={form.message} onChange={handleChange} rows={5} placeholder="Describe your project, goals, and timeline..." required />
                </div>
                <button type="submit" className="btn-primary submit-btn" disabled={loading}>
                  {loading ? <><span className="spinner" /> Sending...</> : <><Send size={16} /> Send Message</>}
                </button>
              </form>
            )}
          </div>

          {/* Info */}
          <div className="contact-info-wrap">
            <h2 className="form-title">Contact Information</h2>
            <div className="gold-line" />
            <div className="contact-info-list">
              {contactInfo.map((c, i) => (
                <div className="contact-info-item" key={i}>
                  <div className="ci-icon">{c.icon}</div>
                  <div>
                    <strong>{c.label}</strong>
                    <span>{c.value}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="map-placeholder">
              <img
                src="https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=600&q=80"
                alt="Pune city"
              />
              <div className="map-overlay">
                <MapPin size={24} />
                <span>Pune, Maharashtra</span>
              </div>
            </div>

            <div className="contact-note">
              <strong>Free Initial Consultation</strong>
              <p>Schedule a complimentary 45-minute strategy call with our senior consultants — no obligations, just value.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
